import { getConsumerUrl } from "@sill/shared";

// The consumer app is a separate origin from the pro surface. Fall back to the
// production app host when no env override is set (local/dev usually has it).
const CONSUMER_BASE_URL =
  import.meta.env.VITE_CONSUMER_URL || "https://app.usesill.com";

/**
 * Shown when a signed-in Clerk user is NOT an agent / loan officer — detected
 * server-side via a 403 from `/api/professional/profile` (the access probe in
 * ProAuthGate), never a client-trusted role. They get a clear explanation and a
 * route back to the consumer app rather than a broken authed shell.
 */
export function NotAProScreen() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-bg-warm p-6">
      <div className="max-w-[460px] text-center">
        <h1 className="view-h1 text-[22px]">
          This area is for agents and loan officers
        </h1>
        <p className="view-sub mt-2.5">
          Your account isn't set up as a Sill pro. If you're a home buyer, head
          back to the Sill app to keep working on your purchase.
        </p>
        <a
          className="ra-view mt-[18px] inline-flex no-underline"
          href={getConsumerUrl(CONSUMER_BASE_URL, "")}
        >
          Go to the Sill app
        </a>
      </div>
    </div>
  );
}
